import { combineEpics, ofType } from 'redux-observable';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import { normalize } from 'normalizr';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { fetchFavoritesSuccess, addFavoriteSuccess, removeFavoriteSuccess } from './actions';
import { favoriteSchema, favoritesSchema } from '../../../store/schema';
import { entitiesFetchSuccess } from '../../../store/entities/actions';

const fetchEpic = action$ =>
  action$.pipe(
    ofType(actionTypes.FETCH),
    switchMap(() =>
      api.myFavorites.fetchAll().pipe(
        mergeMap(response => {
          const { entities } = normalize(response.body, favoritesSchema);
          const ids = response.body.map(f => f.favorite.id);
          return [entitiesFetchSuccess(entities), fetchFavoritesSuccess(ids)];
        }),
        catchError(error => [handleError(error)]),
      ),
    ),
  );

const addDocumentEpic = action$ =>
  action$.pipe(
    ofType(actionTypes.ADD_FAVORITE),
    mergeMap(action =>
      api.myFavorites.addFavorite(action.entityType, action.entityId).pipe(
        mergeMap(response => {
          const { entities } = normalize(response.body, favoriteSchema);
          return [entitiesFetchSuccess(entities), addFavoriteSuccess(action.entityId)];
        }),
        catchError(error => [handleError(error)]),
      ),
    ),
  );

const removeDocumentEpic = action$ =>
  action$.pipe(
    ofType(actionTypes.REMOVE_FAVORITE),
    mergeMap(action =>
      api.myFavorites.removeFavorite(action.entityType, action.entityId).pipe(
        mergeMap(() => [removeFavoriteSuccess(action.entityId)]),
        catchError(error => [handleError(error)]),
      ),
    ),
  );

export default combineEpics(fetchEpic, addDocumentEpic, removeDocumentEpic);
